<template>
<div class="seat-selection-container">
  <div class="top-status">
    <div class="reject-select">
      <i class="iconfont icon-zuowei"></i>
<!--      <i class="iconfont icon-zuowei3"></i>-->
      <span class="select-text">不可选</span>
    </div>
    <div class="allow-select">
      <i class="iconfont icon-zuowei3"></i>
      <span class="select-text">可选</span>
    </div>
  </div>
  <div class="seats-item" id="bus-seat">
  </div>
</div>
</template>

<script>
import SeatsChart from '@/utils/Seats';
import Trains from '@/apis/Trains';

export default {
  props: ['bookDate'],
  name: 'SeatSelection',
  data() {
    return {
      seatChart: undefined,
      // 自然数表示座位，0表示空，-1表示空位，-2表示门
      // reservedSeats: [[1, 2,53], [1, 2,63], [1, 2,49],[1,2],[1, 2,31],[1, 2,22],[1,2]], // 默认选中的座位
      reservedSeats:[],
      bookedSeats: [],
      seatsMatrix: [
        [
          [1, 0, 0, 0, 2],
          [3, 4, 0, 5, 6],
          [7, 8, 0, 9, 10],
          [11, 12, 0, 13, 14],
          [15, 16, 0, 17, 18],
          [19, 20, 0, 21, 22],
          [23, 24, 0, 25, 26],
          [27, 28, 0, 0, 0],
          [29, 30, 0, 0, 0],
          [31, 32, 0, 33, 34],
          [35, 36, 0, 37, 38],
          [39, 40, 0, 41, 42],
          [43, 44, 0, 45, 46],
          [47, 48, 0, 49, 50],
          [51, 52, 53, 54, 55],
        ],
        [
          [1, 0, 0, 0, 0, 2],
          [3, 4, 5, 0, 6, 7],
          [8, 9, 10, 0, 11, 12],
          [13, 14, 15, 0, 16, 17],
          [18, 19, 20, 0, 21, 22],
          [23, 24, 25, 0, 26, 27],
          [28, 29, 30, 0, 31, 32],
          [33, 34, 35, 0, 0, 0],
          [36, 37, 38, 0, 39, 40],
          [41, 42, 43, 0, 44, 45],
          [46, 47, 48, 0, 49, 50],
          [51, 52, 53, 0, 54, 55],
          [56, 57, 58, 0, 59, 60],
          [61, 62, 63, 64, 65],
        ], [
          [1, 0, 0, 0, 2],
          [3, 4, 0, 5, 6],
          [7, 8, 0, 9, 10],
          [11, 12, 0, 13, 14],
          [15, 16, 0, 17, 18],
          [19, 20, 0, 21, 22],
          [23, 24, 0, 25, 26],
          [27, 28, 0, 0, 0],
          [29, 30, 0, 0, 0],
          [31, 32, 0, 33, 34],
          [35, 36, 0, 37, 38],
          [39, 40, 0, 41, 42],
          [43, 44, 0, 45, 46],
          [47, 48, 49, 50, 51],
        ],[
          [1, 0, 2, 3],
          [4, 5, 0, 0],
          [6, 7, 0, 8],
          [9, 10, 0, 11],
          [12, 13, 14, 15],
        ],[
          [1, 0, 0, 0, 2],
          [3, 4, 0, 5, 6],
          [7, 8, 0, 9, 10],
          [11, 12, 0, 13, 14],
          [15, 16, 0, 17, 18],
          [19, 20, 0, 0, 0],
          [21, 22, 0, 23, 24],
          [25, 26, 0, 27, 28],
          [29, 30, 31, 32, 33],

        ],[
          [1, 0, 0, 2],
          [3, 4, 0, 5],
          [6, 7, 0, 0],
          [8, 9, 0, 10],
          [11, 12, 0, 13],
          [14, 15, 0, 16],
          [17, 18, 0, 19],
          [20, 21, 22, 23],

        ],[
          [1, 0, 0, 2],
          [3, 0, 0, 4],
          [5, 0, 0, 6],
        ]


      ],
    };
  },
  mounted() {
    this.queryResvSeats();
    this.$nextTick(() => {
      this.initSeats();
    });
  },
  watch: {
    // bookDate() {
    //   this.queryResvSeats();
    // },
    // reservedSeats(newValue) {
    //   this.refreshSeats(newValue);
    // },
  },
  computed: {
    reserved() {
      // return [...this.reservedSeats[this.type], ...this.bookedSeats];
      return [...this.reservedSeats, ...this.bookedSeats];
    },
    seats() {
      return this.seatsMatrix[this.type];
    },
    type() {
      const busType = +this.$route.query.shuttleType;
      let type = 3;
      // type == 0, 表示55座位, type == 1： 表示65座位,
      // type=2 65座位,type=3表示15座位，type=4表示33座位
      //type = 7 代表7座
      console.log(busType);
      if (busType === 1) {
        type = 0;
      } else if (busType === 2) {
        type = 1;
      } else if (busType === 3) {
        type = 2;
      } else if(busType == 5) {
        type = 3;
      }else if(busType == 4) {
        type = 4;
      }else if(busType == 6) {
        type = 5;
      }else if(busType == 7) {
        type = 6;
      }
      return type;
    },
  },
  methods: {
    async queryResvSeats(bookDate) {
      const params = { id: this.$route.query.id, date: bookDate || this.bookDate };
      // console.log('querySeats ---> ', JSON.stringify(params));
      const res = await Trains.getReservedSeats(params);

      if (res?.data?.reserved_seat_number) {
        console.log(res?.data?.reserved_seat_number)
        this.bookedSeats = res?.data?.reserved_seat_number.map((val) => +val);
        this.reservedSeats = res?.data.disable_seat;
      }

     if (res?.data?.is_full == 1) {

         this.$emit('isClickFull',{is_full:res?.data?.is_full,is_two_bus:res?.data?.is_two_bus})
      }

      // console.log('已预约的座位 -> ', this.bookedSeats);
      // console.log(JSON.stringify(res));
      // let list = this.reservedSeats[this.type];
      // list.push(...res?.data?.reserved_seat_number);
      // list = list.map((item) => +item);
      // list = new Set(list);
      // this.$set(this.reservedSeats, this.type, Array.from(list));
      this.seatChart.clearAll();
      this.initSeats();
      this.refreshSeats(this.reserved); // 刷新disabled坐标
    },
    initSeats() {
      console.log(this.seats);
      this.seatChart = new SeatsChart({
        seats: this.seats,
        disabledPosition: this.reserved,
      });
      this.seatChart.init('bus-seat');
    },
    refreshSeats(seats) {
      this.seatChart.updateDisabledSeats(seats);
    },
  },
};
</script>

<style lang="scss" scoped>
.seat-selection-container {
  flex-basis: 0;
  flex-grow: 1;
  background-color: #fff;
  height: 100%;
  overflow-y: auto;
  padding: 10px 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.top-status {
  display: flex;
  align-items: center;
  justify-content: center;
  .select-text {
    font-size: 12px;
    color: #999999;
    margin-left: 2px;
  }
  .reject-select {
    margin-right: 20px;
    color: #669999;
  }
  .allow-select {
    color: #e3e3e3;
  }
  .allow-select, .reject-select {
    display: flex;
    align-items: center;
  }
}

.bus-seat-row {
}
#bus-seat {
  flex-grow: 1;
  height: 100%;
  width: 100%;
}
</style>
